module.exports = __webpack_public_path__ + "img/galery6.ef5aaffb.jpg";